import React, { useEffect, useRef } from "react";
import { TPrivacyStatementProps } from "../../types/PrivacyStatement.types";
import { PrivacyStatementModel } from "../../models/PrivacyStatement.model";
import { windowService } from '../../../../utils/window.utils.js';
import SectionContent from "../SectionContent";
import Dropdown from "../Dropdown";
import SectionTabs from "./SectionTabs";

const DesktopPrivacyStatement = (props: TPrivacyStatementProps) => {
    const model = new PrivacyStatementModel(props);
    const contentWrapperRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        windowService()?.scrollTo(0, 0);
      }, []);

    return (
        <section className="privacy-statement">
            <div className="privacy-statement__container">
                <div ref={contentWrapperRef} className="privacy-statement__content-wrapper">
                    <div className="privacy-statement__title">{model.title.value}</div>
                    <section className="privacy-statement__content">
                        {
                            model?.items && model.items.map((item) => {
                                return (
                                    <div className="privacy-statement__content-tab" id={item.id}>
                                        <SectionContent {...item} />
                                    </div>
                                )
                            })
                        }
                    </section>
                </div>
                <div className="privacy-statement__tabs-wrapper">
                    <Dropdown
                     languageCollection={model.languageCollection}
                     changeLanguageTitle={model.changeLanguageTitle?.value || ''}
                     languageTitle={model.defaultLanguageTitle?.value || ''}
                    />
                    <SectionTabs contentWrapperRef={contentWrapperRef} privacyContentItems={model.items} />
                    
                </div>
            </div>
        </section>
    );
}

export default DesktopPrivacyStatement;